import { helpers } from '@/helpers.ts';

export const OFFERING_IDS = {
  giftId: Number(helpers.getEnvVar('VITE_OFFERING_ID_GIFTS', '1')),
  premiumId: Number(helpers.getEnvVar('VITE_OFFERING_ID_PREMIUM', '2'))
};
